export default __webpack_public_path__ + "static/media/star.de82f684.svg";